import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Icon from '../../components/AppIcon';
import NavigationBar from '../../components/ui/NavigationBar';
import ProfileTab from './components/ProfileTab';
import BillingTab from './components/BillingTab';
import TeamTab from './components/TeamTab';
import IntegrationsTab from './components/IntegrationsTab';
import SecurityTab from './components/SecurityTab';

const AccountSettings = () => {
  const [activeTab, setActiveTab] = useState('profile');

  const tabs = [
    {
      id: 'profile',
      label: 'Profile',
      icon: 'User',
      component: ProfileTab
    },
    {
      id: 'billing',
      label: 'Billing',
      icon: 'CreditCard',
      component: BillingTab
    },
    {
      id: 'team',
      label: 'Team',
      icon: 'Users',
      component: TeamTab
    },
    {
      id: 'integrations',
      label: 'Integrations',
      icon: 'Plug',
      component: IntegrationsTab
    },
    {
      id: 'security',
      label: 'Security',
      icon: 'Shield',
      component: SecurityTab
    }
  ];

  const ActiveComponent = tabs?.find(tab => tab?.id === activeTab)?.component;

  return (
    <>
      <Helmet>
        <title>Account Settings - WebForms</title>
        <meta name="description" content="Manage your WebForms account settings, billing, team members, integrations, and security preferences" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <NavigationBar stats={{}}>

        <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-12">
          <div className="mb-6 md:mb-8">
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground mb-2">
              Account Settings
            </h1>
            <p className="text-sm md:text-base lg:text-lg text-muted-foreground">
              Manage your account preferences and team settings
            </p>
          </div>

          <div className="flex flex-col lg:flex-row gap-6 md:gap-8">
            <div className="lg:w-64 flex-shrink-0">
              <div className="bg-card border border-border rounded-lg p-2 lg:sticky lg:top-24">
                <nav className="space-y-1">
                  {tabs?.map((tab) => (
                    <button
                      key={tab?.id}
                      onClick={() => setActiveTab(tab?.id)}
                      className={`
                        w-full flex items-center gap-3 px-4 py-3 rounded-md text-sm font-medium
                        transition-smooth
                        ${activeTab === tab?.id
                          ? 'bg-primary/10 text-primary' :'text-muted-foreground hover:text-foreground hover:bg-muted'
                        }
                      `}
                    >
                      <Icon name={tab?.icon} size={18} />
                      <span>{tab?.label}</span>
                      {activeTab === tab?.id && (
                        <Icon name="ChevronRight" size={16} className="ml-auto" />
                      )}
                    </button>
                  ))}
                </nav>
              </div>
            </div>

            <div className="flex-1 min-w-0">
              {ActiveComponent && <ActiveComponent />}
            </div>
          </div>
        </div>
        </NavigationBar>
      </div>
    </>
  );
};

export default AccountSettings;